import { Icon } from '@pryme/ui';
import type { Service } from '../lib/types';

/** The two credentials a service works with, in plain terms (spec §4.1 / §5 calls them pair B and pair A). */
export function KeyDiagram(props: { service?: Service }) {
  const a = props.service?.keys.find((k) => k.direction === 'A' && k.status === 'active');
  const b = props.service?.keys.find((k) => k.direction === 'B' && k.status === 'active');
  return (
    <figure style={{ margin: 0 }} aria-label="How your credentials work">
      <div className="p-diagram">
        <div>
          <h3><Icon name="signature" size={16} />Your signing key · you sign, Pryme verifies</h3>
          <p className="p-small" style={{ margin: 0 }}>
            Its <strong>secret</strong> half is inside your secret key (<code>PRYME_SECRET_KEY</code>), which stays on your backend and signs its requests to Pryme:
            login code exchange, verification and authorization checks. Pryme keeps only the public half and checks every request with it before anything else happens.
          </p>
          {b && <p className="p-small p-muted" style={{ margin: '0.6rem 0 0' }}>Active <code className="p-mono-chip">{b.id}</code></p>}
        </div>
        <div>
          <h3><Icon name="shieldCheck" size={16} />Pryme's verification key · Pryme signs, you verify</h3>
          <p className="p-small" style={{ margin: 0 }}>
            A <strong>public</strong> key, also carried inside your secret key, that your backend uses to check Pryme's responses to it. It is your pinned trust anchor for
            the channel. Each secret key has its own; Pryme holds the private half. Proofs about people are signed by Pryme's attestation issuer instead, whose keys arrive
            over this channel, so they never depend on which secret key a backend runs.
          </p>
          {a && <p className="p-small p-muted" style={{ margin: '0.6rem 0 0' }}>Active <code className="p-mono-chip">{a.id}</code></p>}
        </div>
      </div>
      <figcaption className="p-small p-muted" style={{ marginTop: '0.75rem' }}>
        You configure neither directly: give the SDK your service ID and secret key and it signs and verifies for you. In the protocol specification these are the Service
        B (pair B) and Service A (pair A) keys; they are separate from the person's pairwise keys and from agent keys.
      </figcaption>
    </figure>
  );
}
